import React from 'react';

// Material UI
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import MuiGrid from '@mui/material/Grid';

// Components
import Spinner from '../spinner';
import Head from './header';
import Items from './items';
import CreateFab from '../buttons/create';
import useStyles from './styles';
import { Fab } from '@mui/material';

//Icons
import GetAppIcon from '@mui/icons-material/GetApp';
import { FabContainer } from '@arredo/reactjs-ui';

const Grid = ({
    titleGrid, heads, keyColumns, items, onCreate, createLabel, onUpdate, onDelete, onCopy, onView, pageNumber, totalPage, onChangePage, paginationProps, loading, showActiveInactive,
    onShowUpdate, onShowDelete, customCells, onSelect, isSelected, customFields, onTicketZ, ticketZClick
}) => {
    const { classes } = useStyles();

    return (
        <MuiGrid container spacing={1} className={classes.root}>
            {
                titleGrid &&
                <MuiGrid size={12}>
                    <Paper className={classes.paper}>
                        <Typography variant="h4">
                            {titleGrid}
                        </Typography>
                    </Paper>
                </MuiGrid>
            }
            {
                heads && heads.length > 0 &&
                <MuiGrid sx={{ display: { xs: 'none', lg: 'block' } }} size={12}>
                    <Head
                        align='left'
                        actionsButtons={!!onView + !!onCopy + !!onDelete + !!onUpdate + !!customCells}
                        headers={heads.map(h => ({ value: h }))}
                        selection={!!onSelect}
                    />
                </MuiGrid>
            }
            <MuiGrid size={12}>
                <MuiGrid container spacing={1}>
                    {
                        loading &&
                        <MuiGrid style={{ margin: 8 }} size={12}>
                            <Spinner message='Buscando' />
                        </MuiGrid>
                    }
                    {
                        !loading &&
                        (!items || !items.length) &&
                        <MuiGrid size={12}>
                            <Typography align='center' variant='h6' style={{ margin: 8 }}>
                                No se encontraron resultados
                            </Typography>
                        </MuiGrid>
                    }
                    {
                        !loading && !!items &&
                        items.map((item, index) => (
                            <MuiGrid key={index} size={12}>
                                <Items
                                    align='left'
                                    item={item}
                                    keyColumns={keyColumns}
                                    onView={onView}
                                    onUpdate={onUpdate}
                                    onDelete={onDelete}
                                    onSelect={onSelect}
                                    isSelected={isSelected}
                                    onShowUpdate={onShowUpdate}
                                    onShowDelete={onShowDelete}
                                    onCopy={onCopy}
                                    showActiveInactive={showActiveInactive}
                                    customCells={customCells}
                                    customFields={customFields}
                                />
                            </MuiGrid>
                        ))
                    }
                </MuiGrid>
            </MuiGrid>
            {
                totalPage > 0 &&
                <MuiGrid container justifyContent='center' size={12}>
                    <Pagination
                        color='primary'
                        count={totalPage}
                        page={pageNumber}
                        onChange={onChangePage}
                        siblingCount={2}
                        {...paginationProps}
                    />
                </MuiGrid>
            }
            {
                onCreate &&
                <CreateFab label={createLabel} onClick={onCreate} />
            }
            {
                onTicketZ &&
                <FabContainer>
                    <Fab
                        color='primary'
                        variant="extended"
                        className={classes.fab}
                        onClick={ticketZClick}
                    >
                        <GetAppIcon className={classes.extendedIcon} />
                        Ticket Z
                    </Fab>
                </FabContainer>
            }
        </MuiGrid>
    );
}

Grid.defaultProps = {
    align: 'center'
}

export default Grid;